import React from 'react';
import Field, { FieldProps } from '../Field';
import { Number } from '../../ui/primitives/Number';

// 'as' must be an instance, anonymous functions are recreated each render
const TextField = ({ child: Component, suggestion, ...fieldProps }) => (
    <Component {...fieldProps} highlighted={fieldProps.value && suggestion === fieldProps.value} />
);

export default function FieldNumber({ as, fieldClassName, ...props }: FieldProps<any>) {
    const Component = as || Number;
    return <Field {...props} as={TextField as any} child={Component} fieldClassName={fieldClassName} />;
}
